import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useTranslation } from '../../i18n';
import styles from './Charts.module.css';

interface Props {
  data: Array<{ condition: string; count: number }>;
}

const CONDITION_ORDER = ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'];

export function ConditionBarChart({ data }: Props) {
  const { t } = useTranslation();

  if (data.length === 0) {
    return <div className={styles.empty}>{t('stats.noData')}</div>;
  }

  const sorted = [...data].sort(
    (a, b) => CONDITION_ORDER.indexOf(a.condition) - CONDITION_ORDER.indexOf(b.condition)
  );

  const labeled = sorted.map((d) => ({
    ...d,
    label: t(`condition.${d.condition}` as any) || d.condition,
  }));

  return (
    <div className={styles.chartCard}>
      <h3 className={styles.chartTitle}>{t('stats.conditionBreakdown')}</h3>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={labeled} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis
              dataKey="label"
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
            />
            <YAxis
              allowDecimals={false}
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
            />
            <Tooltip
              cursor={{ fill: 'var(--accent)', opacity: 0.08 }}
              contentStyle={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--text-primary)',
                fontSize: '0.75rem',
              }}
            />
            <Bar dataKey="count" fill="var(--accent)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
